import * as React from 'react';

import { icons, mainPages } from '../routes';
import HomeLink from './HomeLink';

const ModalHome: React.FC = () => {
	return (
		<>
			<div className="modal-home">
				{Object.entries(mainPages).map(([page, link]) => {
					return (
						<HomeLink icon={icons[page.replaceAll(' ', '_')]} key={page} link={link} page={page} />
					);
				}
				)}
			</div>
		</>
	);
};

export default React.memo(ModalHome);
